'use strict';

require('./bootstrap');
require('./directives/PageController');